import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { NEVER, Observable, of } from 'rxjs';

import { Document } from '../models/document.model';

import { catchError, delay, map, tap } from 'rxjs/operators';
import { GlobalSettingsService } from '../services/ui/global-settings.service';
import { BoardService } from '../services/sections/job/board.service';
import { JobDocumentsService } from '../services/sections/job/job-documents.service';
import { ProposalService } from '../services/sections/job/proposal.service';

@Injectable({
	providedIn: 'root'
})
export class ProposalDocumentsResolver implements Resolve<Observable<Document[]>> {
	constructor(
		private router: Router,
		private proposalService: ProposalService
	) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot) {

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		return this.proposalService
			.getProposalDocuments(activatedRouteSnapshot.paramMap.get('token'))
			.pipe(
				catchError(() => {
					this.router.navigate(['/404']);
					GlobalSettingsService.isSecondaryLoaderLoading = false;
					return NEVER;
				})
			);
	}
}
